import { differenceInDays } from 'date-fns';
import { isEmpty, trim } from 'lodash-es';
import useStore from './store';
import produce from 'immer';

const daysToExpiryForSubscriptionAlert = 30;

const AlertTypes = {
  subscription: 'subscription',
};

const setAlertMessage = (message) => {
  useStore.setState(
    produce((draft) => {
      const shouldShow =
        !isEmpty(trim(message)) && draft.alert.message !== message;
      draft.alert.message = message;
      draft.alert.show = shouldShow;
    }),
  );
};

const hideAlert = () => {
  useStore.setState(
    produce((draft) => {
      draft.alert.show = false;
    }),
  );
};

const checkForSubscriptionAlert = (subscription) => {
  const daysToExpiry = subscription
    ? differenceInDays(new Date(subscription.endDate), new Date())
    : -1;
  if (daysToExpiry <= daysToExpiryForSubscriptionAlert) {
    setAlertMessage(AlertTypes.subscription);
  }
};

export {
  setAlertMessage,
  hideAlert,
  daysToExpiryForSubscriptionAlert,
  AlertTypes,
  checkForSubscriptionAlert,
};
